import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../app/hooks'
import Header from '../../../components/header/Header'
import { selectedProject } from '../../home/appSlice/appslice'
import ShopContainer from '../container/ShopContainer'

const ShopPage = () => {
  const project = useAppSelector(selectedProject)
  const navigate = useNavigate()

  useEffect(() => {
    if (!project) {
      navigate('/')
    }
  }, [project])
  return (
    <>
      {project && (
        <>
          <Header title="Shop" />
          <ShopContainer />
        </>
      )}
    </>
  )
}

export default ShopPage
